module.exports = __webpack_public_path__ + "03_long_gray.ce14af6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/03_long_gray.png
// module id = M2xc
// module chunks = 0